module.exports = "#define SHADER_NAME_B64 bGlnaHRQYXNzLnZlcnQ=\nlayout(location=0) in vec2 a_Position;\r\nuniform vec4 u_InvProj;\r\nuniform vec4 u_Transform;\r\nout vec2 v_Position;\r\nvoid main() {\r\n  vec2 pos = a_Position * u_Transform.xy + u_Transform.zw;\r\n  gl_Position = vec4(pos, 0.0, 1.0);\r\n  v_Position = pos * u_InvProj.xy;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/graphics/deferred/lightPass.vert
// module id = 250
// module chunks = 0